export function comVal(val, obj, type = false) {
    // Convert the input object into an array of key-value pairs
    const data = Object.entries(val);
    console.log({data})
    // if (!type) {
    //   const updatedData = data
    //     .filter(([key, value]) => Array.isArray(value))
    //     .map(([key, value]) => ({ [key]: value }));
    //   const updatedData12 = updatedData.map(item => {
    //     const [oldKey, value] = Object.entries(item)[0]; // Get the old key and value
    //     const newKey = obj[oldKey] || oldKey; // Get the new key or default to the old key if not found in mapping
    //     return { [newKey]: value }; // Create new object with the updated key
    //   });
    //   return updatedData12
    // }
    // Filter the array to include only entries where the value is an array
      // if (!type) {
    //   const updatedData = data
    //     .filter(([key, value]) => Array.isArray(value))
    //     .map(([key, value]) => ({ [key]: value }));
    //   const updatedData12 = updatedData.map(item => {
    //     const [oldKey, value] = Object.entries(item)[0]; // Get the old key and value
    //     const newKey = obj[oldKey] || oldKey; // Get the new key or default to the old key if not found in mapping
    //     return { [newKey]: value }; // Create new object with the updated key
    //   });
    //   return updatedData12
    // }
    // Filter the array to include only entries where the value is an array
    if (!type) {
      const updatedData = data
        .filter(([key, value]) => 
          Array.isArray(value) || key === "bp" || key === "lastBp"
        )
        .map(([key, value]) => {
          // Wrap string in array for bp or lastBp
          const safeValue = (key === "bp" || key === "lastBp") && !Array.isArray(value)
            ? [value]
            : value;
          return { [key]: safeValue };
        });
    
      const updatedData12 = updatedData.map(item => {
        const [oldKey, value] = Object.entries(item)[0];
        const newKey = obj[oldKey] || oldKey;
        return { [newKey]: value };
      });
    console.log({updatedData12})
      return updatedData12;
    }
    
    else {
      const updatedData = data.map(([key, value]) => ({ [key]: value }));
      console.log("UPDATED",updatedData)
      const updatedData12 = updatedData.map(item => {
        const [oldKey, value] = Object.entries(item)[0]; // Get the old key and value
        const newKey = obj[oldKey] || oldKey; // Get the new key or default to the old key if not found in mapping
        return { [newKey]: value }; // Create new object with the updated key
      });
      console.log({updatedData12})

      return updatedData12
    }

  }

  export const removeEmptyStringValues = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === '' ||obj[key] === undefined) {
        delete obj[key];
      }
    });
    return obj;
  };

  export const replaceKeys = (obj, keyMap) => {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = keyMap[key] || key; // Use the new key if it exists in the map, otherwise keep the old key
      acc[newKey] = obj[key];
      return acc;
    }, {});
  };

  export   const calAge = (dateVal) => {
    const birthDate = new Date(dateVal);

    // Get the current date
    const today = new Date();

    // Calculate the difference in years
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust if the birth date hasn't occurred yet this year
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
    return age

  }

  function isEmptyValue(value) {
    // Check if the value is an empty string, empty array, or false
    return (Array.isArray(value) && value.length === 0) || value === "" || value === false;
  }
  
  export function checkForNoRecord(obj) {
    // Iterate over the object keys
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
  
        // If the value is an object, recursively check the nested object
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          if (!checkForNoRecord(value)) {
            return false; // Return false if any nested value is non-empty
          }
        } else if (!isEmptyValue(value)) {
          // If any value is neither empty string, empty array, nor false, return false
          return false;
        }
      }
    }
    // If all values are empty arrays, empty strings, or false, return true
    return true;
  }


  // export function otherHandle(value) {
  //   for (const key in value) {
  //     const otherKey = `${key}Other`;
  
  //     // If the value is not already an array, convert it to an array
  //     if (!Array.isArray(value[key]) && value[key] !== undefined && value[key] !== null) {
  //       value[key] = [value[key]];
  //     }
  
  //     // Now handle the "Other" logic if it's an array
  //     if (Array.isArray(value[key])) {
  //       if (value[key].includes('Other') && value[otherKey]) {
  //         value[key].push(`Other- ${value[otherKey]}`);
  //       }
  //     }
  //   }
  
  //   console.log({ value });
  //   return value;
  // }
  export function otherHandle(value) {
    const result = {};
  
    for (const key in value) {
      const otherKey = `${key}Other`;
      let val = value[key];
  
      // Skip undefined, null, or empty string directly
      if (val === undefined || val === null || val === '') continue;
  
      // Convert to array if not already
      if (!Array.isArray(val)) {
        val = [val];
      }
  
      // Add custom "Other" text if applicable
      if (val.includes('Other') && value[otherKey]) {
        val.push(`Other- ${value[otherKey]}`);
      }
  
      // Remove falsy values (like empty string) and trim whitespace entries
      val = val.map(v => (typeof v === 'string' ? v.trim() : v)).filter(Boolean);
  
      // Only add to result if the array is not empty
      if (val.length > 0) {
        result[key] = val;
      }
    }
  
    console.log({ value: result });
    return result;
  }

  export const isValid = (value) => {
    // Check if value is a non-empty array
    if (Array.isArray(value) && value.length > 0) return true;
    // Check if value is a non-empty string
    if (typeof value === "string" && value.trim() !== "") return true;
    // Check if value is boolean
    if (typeof value === "boolean") return true;

    // If none of the above, return false
    return false;
  };